export default __webpack_public_path__ + "dde32f18ca3df47ba9cc72fb3da00556.png";